import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';

import { WebApiModel } from '../../../models/web-api.model';
import { RouterHelperService } from '../../../services/router-helper.service';

@Component({
  /* eslint-disable @angular-eslint/component-selector */
  selector: 'sidebar-detail',
  templateUrl: './sidebar-detail.component.html',
  styleUrls: ['./sidebar-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SidebarDetailComponent implements OnChanges {
  @Input() locationDetail: WebApiModel.LocationDetail;
  placeLink: any[];
  personLink: any[];

  ngOnChanges() {
    if (this.locationDetail.practiceName) {
      const id = this.locationDetail.id;
      const routeType = RouterHelperService.routeType.placeProfile;
      const route = RouterHelperService.getRoute(routeType, id, this.locationDetail.practiceName, null);
      this.placeLink = route.link;
    }
    if (this.locationDetail.displayName) {
      const personId = this.locationDetail.personId;
      const routeType = RouterHelperService.routeType.personProfile;
      const route = RouterHelperService.getRoute(routeType, personId, this.locationDetail.displayName, null);
      this.personLink = route.link;
    }
  }
}
